import { FC, ReactNode } from 'react';
import { noop } from 'lodash-es';
import { AText, Box, Overlay } from '@alf/uikit';
import { Icon } from '@namespace/icons2';

import styles from './index.module.css';

interface PaymentFormModalProps {
  title?: string;
  hideModal?: () => void;
  children: ReactNode;
}

export const PaymentFormModal: FC<PaymentFormModalProps> = ({
  title,
  hideModal = noop,
  children
}) => (
  <Overlay
    classNames={{
      wrapperClass: styles.overlay,
      contentClass: styles.overlayContent
    }}
  >
    <Box
      className={styles.modal}
      direction="column"
      onClick={(e) => e.stopPropagation()}
    >
      {title && (
        <Box
          padding="s s s ms"
          align="center"
          justify="between"
          className={styles.header}
        >
          <AText size="l" breed="B" color="po_txt_color_2">
            {title}
          </AText>
          <Box right="xs">
            <Icon
              size="s"
              name="icons/general/action/close"
              color="txt_color_4"
              onClick={hideModal}
              className={styles.closeIcon}
            />
          </Box>
        </Box>
      )}
      <Box justify="center" align="center" padding="ms">
        {children}
      </Box>
    </Box>
  </Overlay>
);
